import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import BookmarkIcon from "@mui/icons-material/Bookmark";

const ReviewNavigator = ({
  currentIndex,
  answers,
  marked,
  onJump,
  title = "Core Algebra Skills",
}) => {
  const totalQuestions = answers.length;

  return (
    <Box
      sx={{
        width: 520,
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
        p: 4,
      }}
    >
      <Typography
        fontWeight={600}
        fontSize={24}
        textAlign="center"
        mb={2}
      >
        {title}
      </Typography>

      <Box sx={{ height: 1.5, backgroundColor: "#d1d5db", mb: 0.5 }} />

      {/* Legend */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          py: 1,
          fontSize: 14,
        }}
      >
        <LegendItem label="Current" type="current" />
        <LegendItem label="Unanswered" type="unanswered" />
        <LegendItem label="For Review" type="review" />
      </Box>

      <Box sx={{ height: 1.5, backgroundColor: "#d1d5db", mb: 3 }} />

      {/* Grid */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(10, 1fr)",
          gap: 2,
          justifyItems: "center",
          mb: 2,
        }}
      >
        {Array.from({ length: totalQuestions }, (_, i) => {
          const isCurrent = i === currentIndex;
          const isAnswered = answers[i] !== null;
          const isReview = marked[i];

          return (
            <Box
              key={i}
              onClick={() => onJump(i)}
              sx={{
                width: 32,
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                fontWeight: 700,
                cursor: "pointer",
                backgroundColor: isAnswered ? "#2563eb" : "#fff",
                color: isAnswered ? "#fff" : "#111827",
                border: isAnswered
                  ? "none"
                  : "2px dotted #9ca3af",
                position: "relative",
              }}
            >
              {isCurrent && (
                <LocationOnOutlinedIcon
                  sx={{
                    position: "absolute",
                    top: -18,
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontSize: 18,
                    color: "#111827",
                  }}
                />
              )}

              {isCurrent ? <u>{i + 1}</u> : i + 1}

              {isReview && (
                <BookmarkIcon
                  sx={{
                    position: "absolute",
                    top: -6,
                    right: -6,
                    fontSize: 14,
                    color: "#dc2626",
                  }}
                />
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

const LegendItem = ({ label, type }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
    {type === "current" && (
      <LocationOnOutlinedIcon sx={{ fontSize: 18 }} />
    )}
    {type === "unanswered" && (
      <Box
        sx={{
          width: 12,
          height: 12,
          border: "2px dotted #9ca3af",
        }}
      />
    )}
    {type === "review" && (
      <BookmarkIcon sx={{ fontSize: 18, color: "#dc2626" }} />
    )}
    <span>{label}</span>
  </Box>
);

export default ReviewNavigator;
